import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Collapsible from '../../../components/common/Collapsible';


const TabOneSection = ({ tab, sidebarStatus }) => {
  if (sidebarStatus !== 'done' || _.isEmpty(tab)) {
    return null;
  }
  const tabOneSection = _.map(tab, (val, key) => {
    if (_.isEmpty(val.title)) {
      return (
        <div className="tab-section" key={key}>
          {val.links &&
          val.links.map((p, i) => <div className="link"
                                       dangerouslySetInnerHTML={{ __html: p }}
                                       key={`searchlink${i}`} />)
          }
        </div>
      );
    }
    return (
      <div key={key}>
        <Collapsible
          initCollapsed={false}
          title={val.title}
        >
          <div className="tab-section">
            {val.links &&
            val.links.map((p, i) => <div className="link"
                                         dangerouslySetInnerHTML={{ __html: p }}
                                         key={`searchlink${i}`} />)
            }
          </div>
        </Collapsible>
      </div>
    );
  });

  return (
    <React.Fragment>
      { tabOneSection }
    </React.Fragment>
  );
};

TabOneSection.defaultProps = {
  tab: {},
};

TabOneSection.propTypes = {
  tab: PropTypes.object,
  sidebarStatus: PropTypes.string.isRequired,
};

export default TabOneSection;



// WEBPACK FOOTER //
// ./src/pages/filings/FacetsBlock/TabOneSection.jsx